module.exports = __webpack_public_path__ + "img/logo.3049088e.svg";